import { createReducer } from "redux-act";
import createAction from "../utils/createMetaAction";
export const sequenceDescriptionUpdate = createAction(
  "sequenceDescriptionUpdate"
);
export default createReducer(
  {
    [sequenceDescriptionUpdate]: (state, payload) => {
      return payload;
    }
  },
  ""
);
